module.exports = __webpack_public_path__ + "img/lnk-logout.2032aff7.svg";